module.exports = __webpack_public_path__ + "img/datepicker.359a2212.svg";